module.exports = __webpack_public_path__ + "media/images/lb/943-88dfbeb978e0cfeae61960e0a95f5c86.svg";